// extracted by mini-css-extract-plugin
export default {"featured-categories_inner":"FeaturedCategories_featured-categories_inner__zE0SE"};